import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const SocialTwitterIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "SocialTwitter",
    children: /*#__PURE__*/_jsx("path", {
      d: "M27.4 8.02a6 6 0 0 0 2.59-3.23v-.04c-1.07.65-2.34 1.15-3.68 1.41h-.08a5.9 5.9 0 0 0-4.3-1.85c-3.26 0-5.89 2.64-5.89 5.89v.12c0 .44.05.86.14 1.27v-.04c-4.9-.26-9.2-2.59-12.09-6.12l-.02-.03a5.86 5.86 0 0 0-.82 2.96s0 .05 0 .08c0 2.01 1.02 3.77 2.57 4.81h.02c-1.02-.05-1.97-.3-2.82-.72l.04.02v.06a5.99 5.99 0 0 0 4.79 5.77h.04c-.42.14-.91.22-1.42.24-.43-.01-.83-.05-1.23-.12h.05c.78 2.36 2.94 4.03 5.49 4.09a11.8 11.8 0 0 1-7.31 2.53h-.06c-.48 0-.95-.03-1.41-.08h.06c2.54 1.66 5.65 2.64 8.99 2.64h.03c10.82 0 16.76-8.94 16.76-16.77v-.77l-.43-2.13Z"
    })
  }));
};